import React from "react";
import { useSelector } from "react-redux";
import '../../assets/ItemDetails.css';
import { JSONTree } from 'react-json-tree';
import TreeView from "./TreeView";
import { Link } from "react-router-dom";
import { InspectCodeItems } from "../../utils/InspectCodeItems";

export default function ViewDetails() {
  const item = useSelector((state) => state.data.selectedItem);
  const [filter, setFilter] = React.useState('All');

  console.log("Selected item:", item);
  const theme = {
    scheme: 'monokai',
    base00: 'rgb(249 250 251 / var(--tw-bg-opacity, 1))', // background color
    base0D: '#223344', // key color
    base0F: '#443322', // value color
  };

  const codeItemResults = InspectCodeItems(item ? item.codeItem || {} : {});

  const options = {
    weekday: 'short', 
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };



  return (
    <div className="bg-white p-2">
      <div className="w-full flex flex-col h-screen overflow-hidden">
        {item ? (
          <>
            <p className="text-left"><strong>ID:</strong> {item.runId}</p>
            <p className="text-left"><strong>Format Name:</strong> {item.formatName}</p>
            <p className="text-left"><strong>Format Number:</strong> {item.formatNumber}</p>
            <p className="text-left"><strong>Execution Date:</strong> {item.executionDate ? new Date(item.executionDate).toLocaleString('en-US', options) : ''}</p>
            <p>&nbsp;</p>
            <p className="text-left font-bold">Code Items:</p>
            <p>Filter(s): 
              <Link onClick={() => setFilter('All')} className={`text-blue-500 ml-3 ${filter === 'All' ? 'font-bold underline' : ''}`}>All</Link> ({Object.keys(item.codeItem || {}).length}) |
              <Link onClick={() => setFilter('Success')} className={`text-blue-500 ml-3 ${filter === 'Success' ? 'font-bold underline' : ''}`}>Success</Link> ({codeItemResults.Success}) |
              <Link onClick={() => setFilter('Warnings')} className={`text-blue-500 ml-3 ${filter === 'Warnings' ? 'font-bold underline' : ''}`}>Warnings</Link> ({codeItemResults.Warnings}) |
              <Link onClick={() => setFilter('Errors')} className={`text-blue-500 ml-3 ${filter === 'Errors' ? 'font-bold underline' : ''}`}>Errors</Link> ({codeItemResults.Errors})
            </p>
            <div className="py-2 overflow-y-auto" style={{ backgroundColor: 'rgb(249 250 251 / var(--tw-bg-opacity, 1))', borderRadius: '0.375rem' }}>
              <TreeView data={item.codeItem || {}} filter={filter} />
            </div>
          </>
        ) : (
          <p className="text-left text-gray-500">No item selected.</p>
        )}
        <div className="h-[64px]"></div>
      </div>
    </div>
  );
}